import { httpClient } from "./httpClient";
import pickBy from "lodash/pickBy"

const END_POINT = "/exam-event";

export const event = {
  save(examEvent) {
    const { id, title, description, range } = examEvent;
    const body = { title, description, ...range };
    if (id) {
      return httpClient.put(`${END_POINT}/${id}`, body);
    } else return httpClient.post(`${END_POINT}`, body);
  },

  get(id) {
    return httpClient.get(`${END_POINT}/${id}`);
  },

  findAll() {
    return httpClient.get(`${END_POINT}`);
  },
  results(eventId, query) {
    return httpClient.get(`exam-results/${eventId}`, { params: pickBy(query) });
  },
};
